import { postRequest } from '@/core';
import { legs } from '@/requests';

export default async function sendLegRequest({ legId, tripId }) {
	let url = legs.getSendPath(legId);
	let response = await postRequest(url, {}, { tripId });
	return response;
}
